import React, { FC } from 'react'
import { WithdrawalEdit } from '../../edit'
import { formatMoney } from '../../../../../libs/utils'

type TransactionAmountsBlockProps = {
  withdrawal: WithdrawalEdit
  loading: boolean
  errorAmount: { message: string }
  success: { message: string }
}

const cellStyle: React.CSSProperties = {
  background: 'var(--crm-bg)',
  border: '1px solid var(--crm-border)',
  borderRadius: 8,
  padding: 14,
}

const labelStyle: React.CSSProperties = {
  fontSize: 10,
  fontWeight: 600,
  color: 'var(--crm-text-secondary)',
  textTransform: 'uppercase',
  letterSpacing: '0.07em',
  marginBottom: 8,
}

const mainStyle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  fontFamily: 'monospace',
  marginBottom: 4,
}

const subStyle: React.CSSProperties = {
  fontSize: 14,
  fontFamily: 'monospace',
  color: 'var(--crm-text-secondary)',
}

export const TransactionAmountsBlock: FC<TransactionAmountsBlockProps> = ({
  withdrawal,
}) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 10,
        marginTop: 14,
      }}
    >
      {/* Initial */}
      <div style={cellStyle}>
        <div style={labelStyle}>Initial {withdrawal.initialCurrency}</div>
        <div style={mainStyle}>
          {formatMoney(withdrawal.initialAmount, withdrawal.initialCurrency)}
        </div>
        <div style={subStyle}>
          Rate: {Number(withdrawal.exchangeRate)}
        </div>
      </div>

      {/* Client */}
      <div style={cellStyle}>
        <div style={labelStyle}>Client</div>
        <div style={mainStyle}>
          {formatMoney(withdrawal.clientAmount, withdrawal.clientCurrency)}
        </div>
        <div style={subStyle}>
          Commission: {formatMoney(withdrawal.clientCommission, withdrawal.clientCurrency)}
        </div>
      </div>

      {/* Company */}
      <div style={cellStyle}>
        <div style={labelStyle}>Company</div>
        <div style={mainStyle}>
          {formatMoney(withdrawal.companyAmount, withdrawal.companyCurrency)}
        </div>
        <div style={subStyle}>
          Commission: {formatMoney(withdrawal.companyCommission, withdrawal.companyCurrency)}
        </div>
      </div>

      {/* Commissions */}
      <div style={cellStyle}>
        <div style={labelStyle}>Commissions {withdrawal.commissionCurrency}</div>
        <div style={{
          ...subStyle,
          color: Number(withdrawal.innerCommission) > 0 ? 'var(--crm-accent-amber, #f59e0b)' : 'var(--crm-text-secondary)',
        }}>
          Inner: {formatMoney(withdrawal.innerCommission, withdrawal.initialCurrency)}
        </div>
        <div style={{ ...subStyle, marginTop: 4 }}>
          Estimated: {formatMoney(withdrawal.estimatedCommission, withdrawal.companyCurrency)}
        </div>
      </div>
    </div>
  )
}
